import fetch from '@/utils/fetch'

export function loadInfo (id) {
  return fetch({
    url: `/website/hotel/industry/info/${id}`,
    method: 'post'
  })
}

export function saleList (data) {
  return fetch({
    url: '/website/hotel/room/hotel-allow-sale-list',
    method: 'post',
    data
  })
}

// 获取评论
export function loadCommentList (data) {
  return fetch({
    url: '/website/order-review/page',
    method: 'post',
    data
  })
}

export function loadBedType () {
  return fetch({
    url: '/comm/dict/list/bedType',
    method: 'post',
    data: {}
  })
}
